var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManypixelsCareerOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_165_career_outline",
    "data-name": "#165_career_outline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.36,220s14.21-28.69,25.32-35.92c3.83-2.5,60.28-4.75,64.88-.15s3.84,11.39-7.66,13.69a111.42,111.42,0,0,1-19.67,2.29s24.27,2,30.66,0,40.36-19.6,43.17-17.3,8.28,9.5-1.69,15.75-29.48,20.78-35.86,22.57-54.7,18.86-54.7,18.86Z",
    fill: "#ffc9b0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.8,240.78a1.14,1.14,0,0,1-.4-.08L133,220.9a1,1,0,0,1-.49-1.36c.58-1.18,14.46-29,25.67-36.31,2.6-1.69,21.42-2.67,32.68-2.9s30.44-.14,33.46,2.88c2.5,2.5,3.46,5.48,2.64,8.19-.74,2.44-3.22,5.67-10.81,7.19-2.25.45-4.38.81-6.35,1.1,6.63.23,13.85.22,16.83-.74,2.08-.66,7.33-3.09,13.4-5.91,20-9.27,28.69-12.87,30.71-11.22,2.18,1.78,4.63,5.17,4.4,8.86-.2,3.21-2.28,6.07-6.19,8.52-3.15,2-7.28,4.79-11.65,7.78-9.81,6.7-20,13.64-24.47,14.9-6.28,1.76-54.16,18.67-54.64,18.85A1.27,1.27,0,0,1,177.8,240.78ZM134.72,219.5l43.13,19.21c4.85-1.72,48.27-17,54.39-18.76,4.19-1.17,14.65-8.32,23.88-14.62,4.39-3,8.53-5.83,11.72-7.83s5.09-4.42,5.25-6.94c.19-2.94-1.86-5.71-3.66-7.19-2.15-.77-19.37,7.2-28.61,11.49-6.13,2.84-11.43,5.29-13.63,6-6.5,2.08-30,.13-31,0a1,1,0,0,1-.92-1,1,1,0,0,1,1-1,110.79,110.79,0,0,0,19.48-2.27c5.17-1,8.46-3.1,9.29-5.81.59-2-.19-4.24-2.15-6.2-3.93-3.93-59.72-2.25-63.63.28C149.58,191.18,137.27,214.54,134.72,219.5Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.54 244.3 189.36 237.71 131.62 214.79 117.79 244.3 186.54 244.3",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.54,245.3H117.79a1,1,0,0,1-.84-.46,1,1,0,0,1-.06-1l13.83-29.52a1,1,0,0,1,1.27-.5l57.74,22.92a1,1,0,0,1,.55.55,1,1,0,0,1,0,.78l-2.82,6.59A1,1,0,0,1,186.54,245.3Zm-67.17-2h66.51l2.16-5-55.91-22.19Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.67,133.51a1,1,0,0,1-1-1V127a1,1,0,0,1,2,0v5.51A1,1,0,0,1,91.67,133.51Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.67,144.52a1,1,0,0,1-1-1V138a1,1,0,0,1,2,0v5.51A1,1,0,0,1,91.67,144.52Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.93,136.26H94.42a1,1,0,0,1,0-2h5.51a1,1,0,0,1,0,2Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.92,136.26h-5.5a1,1,0,0,1,0-2h5.5a1,1,0,1,1,0,2Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.33,146a1,1,0,0,1-1-1v-5.51a1,1,0,0,1,2,0V145A1,1,0,0,1,290.33,146Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.33,157a1,1,0,0,1-1-1v-5.51a1,1,0,0,1,2,0V156A1,1,0,0,1,290.33,157Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.58,148.7h-5.5a1,1,0,0,1,0-2h5.5a1,1,0,0,1,0,2Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.58,148.7h-5.51a1,1,0,0,1,0-2h5.51a1,1,0,0,1,0,2Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.15,114.94a1,1,0,0,1-1-1V100.8a1,1,0,0,1,2,0v13.14A1,1,0,0,1,305.15,114.94Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.72,108.37H298.58a1,1,0,0,1,0-2h13.14a1,1,0,0,1,0,2Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.94,92.53a1,1,0,0,1-1-1V81.26a1,1,0,1,1,2,0V91.53A1,1,0,0,1,111.94,92.53Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.07,87.4H106.81a1,1,0,0,1,0-2h10.26a1,1,0,0,1,0,2Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.07,172a1,1,0,0,1-1-1V160.69a1,1,0,0,1,2,0V171A1,1,0,0,1,117.07,172Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.21,166.82H111.94a1,1,0,0,1,0-2h10.27a1,1,0,0,1,0,2Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.37,90a3.5,3.5,0,0,1-3.5-3.5V70.71a3.5,3.5,0,0,0-3.5-3.5H183.63a3.5,3.5,0,0,0-3.5,3.5V86.54a3.5,3.5,0,1,1-7,0V70.71a10.51,10.51,0,0,1,10.5-10.5h32.74a10.51,10.51,0,0,1,10.5,10.5V86.54A3.5,3.5,0,0,1,223.37,90Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.37,91a4.51,4.51,0,0,1-4.5-4.5V70.71a2.5,2.5,0,0,0-2.5-2.5H183.63a2.5,2.5,0,0,0-2.5,2.5V86.54a4.5,4.5,0,1,1-9,0V70.71a11.51,11.51,0,0,1,11.5-11.5h32.74a11.51,11.51,0,0,1,11.5,11.5V86.54A4.51,4.51,0,0,1,223.37,91ZM183.63,66.21h32.74a4.51,4.51,0,0,1,4.5,4.5V86.54a2.5,2.5,0,1,0,5,0V70.71a9.51,9.51,0,0,0-9.5-9.5H183.63a9.51,9.51,0,0,0-9.5,9.5V86.54a2.5,2.5,0,1,0,5,0V70.71A4.51,4.51,0,0,1,183.63,66.21Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.22,
    y: 81.46,
    width: 123.57,
    height: 83.81,
    rx: 6.4,
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.39,166.27H144.61a7.41,7.41,0,0,1-7.39-7.4v-71a7.4,7.4,0,0,1,7.39-7.39H255.39a7.4,7.4,0,0,1,7.39,7.39v71A7.41,7.41,0,0,1,255.39,166.27ZM144.61,82.46a5.4,5.4,0,0,0-5.39,5.39v71a5.4,5.4,0,0,0,5.39,5.4H255.39a5.4,5.4,0,0,0,5.39-5.4v-71a5.4,5.4,0,0,0-5.39-5.39Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.61,110H153.39a16.18,16.18,0,0,1-16.17-16.17V86.54a1,1,0,1,1,2,0v7.25A14.18,14.18,0,0,0,153.39,108h93.22a14.18,14.18,0,0,0,14.17-14.17V86.54a1,1,0,0,1,2,0v7.25A16.18,16.18,0,0,1,246.61,110Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.06,
    y: 99.67,
    width: 7.88,
    height: 16.33,
    rx: 3.19,
    fill: "#ffbc0e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.75,117h-1.5a4.2,4.2,0,0,1-4.19-4.19v-9.94a4.2,4.2,0,0,1,4.19-4.2h1.5a4.2,4.2,0,0,1,4.19,4.2v9.94A4.2,4.2,0,0,1,200.75,117Zm-1.5-16.33a2.2,2.2,0,0,0-2.19,2.2v9.94a2.19,2.19,0,0,0,2.19,2.19h1.5a2.19,2.19,0,0,0,2.19-2.19v-9.94a2.2,2.2,0,0,0-2.19-2.2Z",
    fill: "#093f68"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManypixelsCareerOutline);
export default __webpack_public_path__ + "static/media/Manypixels_Career_Outline.03572b7dcd24b3869cf13156a7c0bfd9.svg";
export { ForwardRef as ReactComponent };